import React from 'react';
import type { Editor } from '@tiptap/core';

export interface FontSizePickerProps {
  editor: Editor;
  fontSizes?: string[];
}

const DEFAULT_FONT_SIZES = [
  '8px', '10px', '12px', '14px', '16px', '18px', '20px',
  '24px', '28px', '32px', '36px', '48px', '64px', '72px',
];

export const FontSizePicker: React.FC<FontSizePickerProps> = ({
  editor,
  fontSizes,
}) => {
  const sizes = fontSizes || DEFAULT_FONT_SIZES;
  const currentSize = editor.getAttributes('textStyle').fontSize || '';

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    if (value === '') {
      editor.chain().focus().unsetFontSize().run();
    } else {
      editor.chain().focus().setFontSize(value).run();
    }
  };

  return (
    <select
      className="font-size-picker"
      value={currentSize}
      onChange={handleChange}
      title="Font Size"
    >
      <option value="">Size</option>
      {sizes.map((size) => (
        <option key={size} value={size}>
          {parseInt(size, 10)}
        </option>
      ))}
    </select>
  );
};
